var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnVisibility = function SvgBtnVisibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75c5.208 0 9.817 3.202 11.698 7.975a.75.75 0 0 1 0 .55A12.576 12.576 0 0 1 12 20.25 12.575 12.575 0 0 1 .302 12.275a.75.75 0 0 1 0-.55A12.575 12.575 0 0 1 12 3.75Zm0 1.5a11.073 11.073 0 0 0-10.067 6.473L1.81 12a11.08 11.08 0 0 0 9.582 6.733l.303.013.305.004c4.382 0 8.284-2.575 10.067-6.473L22.19 12a11.077 11.077 0 0 0-9.58-6.733l-.304-.013L12 5.25Zm0 2A4.751 4.751 0 0 1 16.75 12 4.751 4.751 0 0 1 12 16.75 4.751 4.751 0 0 1 7.25 12 4.751 4.751 0 0 1 12 7.25Zm0 1.5A3.251 3.251 0 0 0 8.75 12 3.251 3.251 0 0 0 12 15.25 3.251 3.251 0 0 0 15.25 12 3.251 3.251 0 0 0 12 8.75ZM12 11a1 1 0 1 1 .002 1.998A1 1 0 0 1 12 11Z",
    fill: "#A4A7AD"
  })));
};
export default SvgBtnVisibility;